const ignoredFields = [
  'officialName',
  'assetClass',
  'gpsCoordinates',
  'icon',
  'id',
  'equivalentCO2ProductionOfXXEuropeanHouseholds',
  'mail',
];

const ignoredLabels = ['officialName', 'street', 'houseNumber', 'index', 'city', 'country', 'telephone', 'fax', 'mail'];

const links = {
  de: {
    'Green Logistics': '/sachwertanlagen/green-logistics',
    Hydropower: '/sachwertanlagen/wasserkraft',
    'Solar PV': '/sachwertanlagen/photovoltaik',
    'Wind energy': '/sachwertanlagen/windenergie',
    'Residential': '/sachwertanlagen/wohnungsbau',
  },
  en: {
    'Green Logistics': '/en/real-assets/green-logistics',
    Hydropower: '/en/real-assets/hydropower',
    'Solar PV': '/en/real-assets/solar-pv',
    'Wind energy': '/en/real-assets/wind-energy',
    'Residential': '/en/real-assets/residential',
  },
};

export default (data, translation) => {
  const { language, strings } = translation;

  if (data.mail) {
    const keys = Object.keys(data);
    const email = `<a href="mailto:${data.mail}" class="marker-popup__field marker-popup__link">${strings['contact'][language]}</a>`;
    let fields = '';

    keys.forEach(field => {
      if (ignoredFields.includes(field)) return;

      const title = !ignoredLabels.includes(field)
        ? `<div class="marker-popup__field__title">${strings[field][language]}</div>`
        : '';

      if (field == 'index') {
        fields += `
        <br><div class="marker-popup__field marker-popup__field--${field}">
          ${title}
          <div class="marker-popup__field__value">${data[field]}</div>
        </div>`;
      } else {
        fields += `
          <div class="marker-popup__field marker-popup__field--${field}">
            ${title}
            <div class="marker-popup__field__value">${data[field]}</div>
          </div>`;
      }
    });

    return `
    <div class="marker-popup">
      ${fields}
      ${email}
    </div>
  `;
  } else {
    const keys = Object.keys(data);
    const title = `<div class="marker-popup__title">${data.officialName}</div>`;
    let fields = '<div class="marker-popup__fields">';

    const link = strings['more'] && strings['more'][language] != '' 
            ? `<a href="${
                links[language][data.assetClass]
              }" class="marker-popup__link marker-popup__field">${strings['more'][language]}</a>`
            : '';

    keys.forEach(field => {
      if (ignoredFields.includes(field)) return;

      const fieldTitle = !ignoredLabels.includes(field)
        ? (strings[field] ? `<div class="marker-popup__field__title">${strings[field][language]}</div>` : `<div class="marker-popup__field__title">${field}</div>`)
        : '';

      fields += `
      <div class="marker-popup__fields-item">
        ${fieldTitle}
        <div class="marker-popup__fields-item__value">${data[field]}</div>
      </div>`;
    });

    fields += '</div>';

    return `
    <div class="marker-popup">
      ${title}
      ${fields}
      ${link}
    </div>
  `;
  }
};
